initImageZoom({
  moduleSelector: '.full-width-image-text',
  wrapSelector: '.full-width-image-text__image',
  innerSelector: '.full-width-image-text__image-inner',
  duration: '50%',
  triggerHook: 0.6,
});
